import { Col, Container, Row } from 'react-bootstrap';
import DefaultCard from '../../components/DefaultCard';
import GenericCard from '../../components/GenericCards/GenericCards';
import CustomSelect from '../../components/Select';


import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../utils/utils';




const transactionTableData = [
  {
    requestedDate: '09/01/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Hardship Withdrawal',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -2),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Change Contributions',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -365),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Pension Election',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -730),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Contribution Change',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Rebalance Funds',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Remove Direct Deposit',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Investment Direction',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Home Loan',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Withdrawal',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Pension Direct Deposit',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Withdrawal Rollover',
    endingBalance: '$107,562.39',
  },
];






const today = new Date();

const currentYear = new Date().getFullYear();

const startDate = new Date(currentYear, 0, 1);

const endDate = new Date(today.getFullYear(), today.getMonth(), 0);

const formattedStartDate = formatDate(
  startDate,
  DateFormats.SHORT_MONTH_DAY_YEAR
);
const formattedStartDateUS = formatDate(startDate, DateFormats.US);
const formattedEndDate = formatDate(endDate, DateFormats.SHORT_MONTH_DAY_YEAR);
const formattedEndDateUS = formatDate(endDate, DateFormats.US);

const CR = () => {
  return (
<Container className={'cnd-custom-container mt-11 mb-3'}>
     
      
      <Row className={'mt-13'}>
      
        <Col>
          <GenericCard className={'px-10 py-lg-10'} variant={'white'}>
            <Row className={'align-items-center px-5 py-10'}>
              <Col
                className={'d-flex flex-column col-12 col-lg-3 ms-10 ms-lg-0'}
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Starting Balance - {formattedStartDateUS}
                </span>
                <span className={'text-sm-24-lg-32'}>$53,891.00</span>
              </Col>
              <Col
                className={
                  'd-flex flex-column align-items-lg-center col-12 col-lg-3 mt-13 mt-lg-0 ms-10 ms-lg-0'
                }
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Pay Credits & Adjustments
                </span>
                <span className={'text-sm-24-lg-32'}>$521.98</span>
              </Col>
              <Col
                className={
                  'd-flex flex-column align-items-lg-center col-12 col-lg-2 mt-13 mt-lg-0 ms-10 ms-lg-0'
                }
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Interest Credits
                </span>
                <span className={'text-sm-24-lg-32'}>$179.64</span>
              </Col>
              <Col className={'col-12 col-lg-3 ms-auto mt-11 mt-lg-0'}>
                <DefaultCard
                  className={'py-7 px-10'}
                  leftSubheading={
                    <Row>
                      <Col className={'col-12 text-lg-end mb-3 ps-0'}>
                        <span className={'text-white'}>
                          Ending Balance - {formattedEndDateUS}
                        </span>
                      </Col>
                      <Col className={'col-12 text-lg-end ps-0'}>
                        <span className={'text-sm-24-lg-32'}>$54,592.62</span>
                      </Col>
                    </Row>
                  }
                  variant={'blue'}
                />
              </Col>
            </Row>
            
          </GenericCard>
        </Col>

        
      </Row>




            
      {/*<Row className={'mt-10 mt-lg-0'}>
        <Col className={'col-12'}>
          <GenericCard variant={'gray'}>
            <Row className={'my-11'}>
              <Col>
                <span className={'text-sm-20-lg-24'}>Details</span>
              </Col>
            </Row>

            <Row>
              <Col className={'d-flex flex-column d-lg-block flex-nowrap'}>
                <Row
                  className={
                    'flex-nowrap px-8 px-lg-0 d-flex align-items-center border-bottom-dark-gray py-8'
                  }
                  style={{ minWidth: '650px' }}
                >
                  <Col className={'col-2 col-lg-4 text-fs-6 m-0'}>
                    Start Date
                  </Col>
                  <Col className={'col-2 ps-6 m-0 text-end'}>
                    <span className={'text-fs-6'}>Pay Credits</span>
                  </Col>
                  <Col className={'col-2 text-fs-6 m-0 text-end'}>
                    <span className={'text-fs-6'}>Adjustments</span>
                  </Col>
                  <Col className={'col-3 col-lg-2 text-fs-6 m-0 text-end'}>
                    <span className={'text-fs-6'}>Interest Credits</span>
                  </Col>
                  <Col className={'col-3 col-lg-2 text-fs-6 m-0 text-end'}>
                    <span className={'text-fs-6'}>Ending Balance</span>
                  </Col>
                </Row>
                {transactionTableData.map((transaction, index) => {
                  return (
                    <Row
                      className={
                        'flex-nowrap px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row align-items-center border-bottom border-info'
                      }
                      key={index}
                      style={{ minWidth: '650px' }}
                    >
                      <Col className={'col-2 col-lg-4'}>
                        <span className={'h3 text-fs-6 m-0'}>
                          {transaction.requestedDate}
                        </span>
                      </Col>
                      <Col className={'col-2 text-end'}>
                        <span className={'h3 text-fs-6'}>
                          {transaction.payCredits}
                        </span>
                      </Col>
                      <Col className={'col-2 text-end'}>
                        <span className={''}>{transaction.adjustments}</span>
                      </Col>
                      <Col className={'col-3 col-lg-2 text-end'}>
                        <span className={'fw-light text-fs-6'}>
                          {transaction.interestCredits}
                        </span>
                      </Col>
                      <Col className={'col-3 col-lg-2 text-end'}>
                        <span
                          className={
                            'w-100 text-end text-lg-start h3 text-fs-6 m-0'
                          }
                        >
                          {transaction.endingBalance}
                        </span>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
          </GenericCard>
        </Col>
      </Row>*/}
      




         
    </Container>
   );
};
    export default CR;